import type { Camp } from '@orbomb/content';

/** Bump whenever a change can alter the outcome of an identical input stream. */
export const SIMULATION_VERSION = '0.1.4';

export const TICK_RATE = 60;
export const TICK_SECONDS = 1 / TICK_RATE;

/** Stable processing order for camps everywhere in the simulation. */
export const CAMP_ORDER: readonly Camp[] = ['ORANGE', 'TURQUOISE'];

export function campIndex(camp: Camp): 0 | 1 {
  return camp === 'ORANGE' ? 0 : 1;
}

export function opponentOf(camp: Camp): Camp {
  return camp === 'ORANGE' ? 'TURQUOISE' : 'ORANGE';
}

export function secondsToTicks(seconds: number, name = 'duration'): number {
  const exact = seconds * TICK_RATE;
  const ticks = Math.round(exact);
  if (Math.abs(exact - ticks) > 1e-6) {
    throw new Error(`${name} (${seconds}s) is not a whole number of ${TICK_RATE} Hz ticks`);
  }
  return ticks;
}
